export default __webpack_public_path__ + "static/media/background_img.2ccc6c9b.png";